/**
 * Utility functions for resolving beneficiary / recipient CSS badge color tone classes.
 * Ensures 1:1 color parity across Cuadro Picnic table cells and details dialogs.
 */

/**
 * Resolves the CSS modifier class matching the exact destinatarioServicio column tones.
 * - Pax, TC, Guía: dest-emerald (Green tone-success)
 * - Asist. Guía, Chofer: dest-blue (Blue tone-info)
 * - Per. Campo, Staff, Cocinero: dest-orange (Orange tone-campo)
 *
 * @param recipient - Raw beneficiary string (e.g. 'PAX', 'TC', 'GUIA', 'CHOFER', 'STAFF').
 * @returns CSS modifier class name (e.g. 'dest-emerald', 'dest-blue', 'dest-orange', 'dest-neutral').
 */
export function resolveRecipientBadgeClass(recipient?: string): string {
  if (!recipient) {
    return 'dest-neutral';
  }
  const normalizedCode = recipient
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim();

  // 1. Pax, TC, Guía -> Emerald (dest-emerald)
  if (
    normalizedCode === 'PAX' ||
    normalizedCode.includes('PAX') ||
    normalizedCode.includes('PASAJERO') ||
    normalizedCode === 'TC' ||
    normalizedCode.includes('TC') ||
    (normalizedCode.includes('GUIA') && !normalizedCode.includes('ASIST')) ||
    (normalizedCode.includes('GUIDE') && !normalizedCode.includes('ASSIST'))
  ) {
    return 'dest-emerald';
  }

  // 2. Asist Guía, Chofer -> Blue (dest-blue)
  if (
    normalizedCode === 'ASIST GUIA' ||
    normalizedCode === 'ASISTENTE GUIA' ||
    normalizedCode === 'ASISTENTE DE GUIA' ||
    normalizedCode.includes('ASIST') ||
    normalizedCode.includes('ASSIST') ||
    normalizedCode === 'CHOFER' ||
    normalizedCode === 'DRIVER' ||
    normalizedCode.includes('CHOFER') ||
    normalizedCode.includes('DRIVER') ||
    normalizedCode.includes('CONDUCTOR')
  ) {
    return 'dest-blue';
  }

  // 3. Per. Campo, Cocinero y Staff -> Orange (dest-orange)
  if (
    normalizedCode === 'PERSONAL DE CAMPO' ||
    normalizedCode.includes('CAMPO') ||
    normalizedCode.includes('COCINERO') ||
    normalizedCode.includes('COOK') ||
    normalizedCode === 'STAFF' ||
    normalizedCode.includes('STAFF') ||
    normalizedCode.includes('PERSONAL')
  ) {
    return 'dest-orange';
  }

  return 'dest-emerald';
}
